import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppServiceService } from 'src/app/api/app-service.service';
import { StorageService } from 'src/app/core/storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-invoice-history',
  templateUrl: './invoice-history.page.html',
  styleUrls: ['./invoice-history.page.scss'],
})
export class InvoiceHistoryPage implements OnInit {
  
  public invoiceList = [];

  constructor(public appService: AppServiceService, public storage: StorageService, public translate: TranslateService) { }

  ngOnInit() {
    this.getInvoiceList();
  }

  getInvoiceList() {
    if (this.appService.appObject.isAuthed){
      this.appService.appObject.isLoading = true;
      this.appService.getInvoiceList(this.appService.appObject.userId).then((data: any) => {
        if (data.status) {
          this.invoiceList = data.data;
        }
        this.appService.appObject.isLoading = false;
      }, error => {
        this.appService.appObject.isLoading = false;
      });
    }
  }

  invoiceDownload(file_name){
    let url = environment.API_URL+'invoice/view/'+file_name+'?device_id='+this.appService.appObject.deviceUUID;

    var downloadLink      = document.createElement('a');
    downloadLink.target   = '_blank';
    downloadLink.download = file_name;
  
    // set object URL as the anchor's href
    downloadLink.href = url;
  
    // append the anchor to document body
    document.body.append(downloadLink);
  
    // fire a click event on the anchor
    downloadLink.click();
  
    // cleanup: remove element and revoke object URL
    document.body.removeChild(downloadLink);
  }

}
